import { useEffect } from "react";
import { convertTimeInput } from "../utils/convertTimeInput.js";
import { findIndexOfNearestOption } from "../utils/findIndexOfNearestOption.js";
function useScrollToSelectedItem(open, format, inputValue, selectValue, menuRef, optionsRef, allowEmpty) {
  useEffect(() => {
    selectValue;
    if (!open) return;
    const refOptionValues = optionsRef.current;
    setTimeout(() => {
      const selectedElements = menuRef.current?.querySelectorAll('[data-selected="true"]');
      if (selectedElements && selectedElements.length > 0) {
        selectedElements.item(0).scrollIntoView();
        return;
      }
      const convertedInputValue = convertTimeInput(inputValue, format, allowEmpty);
      if (convertedInputValue === "invalid" || convertedInputValue === null) return;
      const elements = menuRef.current?.getElementsByTagName("li");
      if (!elements) return;
      const indexWithMinInterval = findIndexOfNearestOption(convertedInputValue, refOptionValues);
      if (!indexWithMinInterval) return;
      elements.item(indexWithMinInterval)?.scrollIntoView();
    }, 0);
  }, [format, selectValue, inputValue, menuRef, optionsRef, allowEmpty, open]);
}
export {
  useScrollToSelectedItem
};
//# sourceMappingURL=useScrollToSelectedItem.js.map
